import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/auth';
import { SelectCompanies } from '../../components';

export function UserCompany() {

    const { companiesUser, searchUserLogged } = useAuth()
    const [user, setUser] = useState({})
    const [companies, setCompanies] = useState([])


    const userSystemInfo = useCallback(async () => {
        const [response1, response2] = await Promise.all([
            searchUserLogged(),
            companiesUser()
        ]);
        setUser(response1)
        setCompanies(response2)
    }, []);
    useEffect(() => {
        userSystemInfo();
    }, [])


    return (
        <SelectCompanies
            companies={companies}
            user={user}
        />
    )
}